import { graphql } from '../graphql';

/**
 * Fetches the full set of resource files a project needs to be usable offline,
 * along with the total byte size and per-layer version stamps used for
 * staleness detection in the offline catalog.
 */
export const projectOfflineManifestQuery = graphql(`
  query ProjectOfflineManifest($projectId: ID!) {
    projectOfflineManifest(projectId: $projectId) {
      projectId
      totalBytes
      layerVersions
      files {
        url
        sizeBytes
        layerId
        kind
      }
    }
  }
`);
